﻿///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
(function( doc ) {
    'use strict';
    
    class ContactManager {

        constructor() {
            this.additionalMarkers = [
                {
                    lat: 32.711349,
                    lng: -97.398882,
                    marker: '/img/contact/neiman.v1.png'
                },
                {
                    lat: 32.710360,
                    lng: -97.400599,
                    marker: '/img/contact/clearfork.v1.png'
                },
                {
                    lat: 32.700387,
                    lng: -97.413286,
                    marker: '/img/contact/waterside.v1.png'
                }
            ];

            this.gmapEl = app.$( '#gmap' );
            this.gmap = new app.Gmap( this.gmapEl, _ => this.addAdditionalMarkers() );
        }

        addAdditionalMarkers() {
            this.additionalMarkers.forEach( marker => this.gmap.addMarker( marker ) );
        }
    }

    let cm = new ContactManager(); 

}( document ) );